export default __webpack_public_path__ + "static/media/download-arrow.716bd9d5.svg";